var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSliderVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.75c-.75 0-1.3-.03-1.77-.1-3.32-.36-3.98-2.35-3.98-5.65v-4c0-3.3.66-5.29 4.01-5.66.44-.06.99-.09 1.74-.09h9c.75 0 1.3.03 1.77.1 3.33.37 3.98 2.35 3.98 5.65v4c0 3.3-.66 5.29-4.01 5.66-.44.06-.99.09-1.74.09h-9zM5.95 5.83c-2.03.23-2.7.86-2.7 4.17v4c0 3.31.67 3.94 2.67 4.17.42.06.9.08 1.58.08h9c.68 0 1.16-.03 1.55-.08 2.03-.22 2.7-.86 2.7-4.17v-4c0-3.31-.67-3.94-2.67-4.17-.42-.06-.9-.08-1.58-.08h-9c-.68 0-1.16.03-1.55.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75h-15zM5 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h15c.41 0 .75.34.75.75s-.34.75-.75.75H5z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSliderVertical);
export default __webpack_public_path__ + "static/media/vuesax-outline-slider-vertical.e306a94a61d099d9fe9485ba2b705fba.svg";
export { ForwardRef as ReactComponent };